import date from './date';
import dateSimple from './date-simple';
import money from './money';
import cpfCnpj from './cpf_cnpj';
import phone from './phone';
import cep from './cep';

export default {
  date,
  dateSimple,
  money,
  cpfCnpj,
  phone,
  cep,
};
